import { render, staticRenderFns } from "./MeetingRoomScreen.vue?vue&type=template&id=e2ffb24e&scoped=true"
import script from "./MeetingRoomScreen.vue?vue&type=script&lang=js"
export * from "./MeetingRoomScreen.vue?vue&type=script&lang=js"
import style0 from "./MeetingRoomScreen.vue?vue&type=style&index=0&id=e2ffb24e&prod&scoped=true&lang=css"
import style1 from "./MeetingRoomScreen.vue?vue&type=style&index=1&id=e2ffb24e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ffb24e",
  null
  
)

export default component.exports